module.exports = __webpack_public_path__ + "static/img/consumer-h5-3.1aea5b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/consumer-h5-3.png
// module id = bcXf
// module chunks = 34